import { PixImg, CreditCardImg } from '../../helpers/images';
import { PIX, CREDITCARD } from '../../helpers/constants';

export default function PaymentOption({
  handlePix,
  handleCreditCard,
  transaction,
  t,
}) {
  return (
    <fieldset className='mb-4'>
      <legend className='site-title site-title--sm mb-3'>{t('payment.title')}</legend>
      <div className='pay-options'>
        <label
          className='pay-option'
          htmlFor='transaction-payment-type-pix'
        >
          <input
            id='transaction-payment-type-pix'
            name='transaction-payment-type'
            type='radio'
            className='form-check-input mt-0'
            value={transaction.paymentType}
            checked={transaction.paymentType === PIX}
            onChange={handlePix}
          />
          <span className='pay-option__label'>{t('pix.fields.title')}</span>
          <img
            alt=''
            src={PixImg}
          />
        </label>
        <label
          className='pay-option'
          htmlFor='transaction-payment-type-credit-card'
        >
          <input
            id='transaction-payment-type-credit-card'
            name='transaction-payment-type'
            type='radio'
            className='form-check-input mt-0'
            value={transaction.paymentType}
            checked={transaction.paymentType === CREDITCARD}
            onChange={handleCreditCard}
          />
          <span className='pay-option__label'>{t('cctoken.fields.title')}</span>
          <img
            alt=''
            src={CreditCardImg}
          />
        </label>
      </div>
    </fieldset>
  );
}
